// removed by extract-text-webpack-plugin
module.exports = {"mobile":"mobile___20ki_","header":"header___1rM1t","app-store-link":"app-store-link___2ZVFT","ios":"ios___1BtPW","android":"android___19H4U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Mobile/Mobile.scss
// module id = rWG9
// module chunks = 60